export default __webpack_public_path__ + "static/platform2-bb976c573e628a8c1f1ffa1a19f85405.svg";